import React from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { Add as AddIcon } from '@mui/icons-material';
import { TableSuscripciones } from './components/TableSuscripciones';
import { BannerInfoSuscripciones } from './components/BannerInfoSuscripciones';
import { hasPemissions } from 'commons/utils';
import { PageLayout } from 'components/generics/PageLayout';

export const SuscripcionesIa = () => {
    const [canCreate, setCanCreate] = React.useState(false);

    const checkPermissions = async () => {
        const create = await hasPemissions('modulo.manager', 'modulo.manager.plataforma.ia', 'create', 'modulo.manager.plataforma.ia.comercial', 'modulo.manager.plataforma.ia.comercial.suscripciones');
        setCanCreate(create);
    };

    React.useEffect(() => {
        checkPermissions();
    }, []);

    return (
        <PageLayout
            title="Suscripciones IA"
            mainModule="Plataforma IA"
            icon="ListAlt"
            infoAlert="Administración de suscripciones de clientes para los servicios de inteligencia artificial."
            actionButtons={
                <>
                    {canCreate && (
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            component={Link}
                            to={'/manager/plataforma-ia/comercial/suscripciones/crear'}
                            sx={{
                                borderRadius: 2,
                                px: 3,
                                py: 1,
                                fontWeight: 600,
                                textTransform: 'none',
                                boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)'
                            }}
                        >
                            Nueva Suscripción
                        </Button>
                    )}
                </>
            }
        >
            <TableSuscripciones />
            <BannerInfoSuscripciones />
        </PageLayout>
    );
};
